export function validateAgency(data: Record<string, unknown>): string[] {
    const errors: string[] = [];

    if (!data.label) {
        errors.push('Libellé requis.');
    }

    if (!data.code) {
        errors.push('Code requis.');
    }

    return errors;
}
